<template>
  <div class="weather_box">
    <card title="气象预报">
      <div class="weather_box box_style">
        <div class="box_header">
          <div class="weather_icon" @click="handleControlWeather">
            <img :src="`${require(`@/assets/hs/${nowWeatherIcon}.png`)}`" alt="" class="Img" />
          </div>
          <div class="weather_temp">{{ nowWeather.temp }}°</div>
          <div class="weather_info">
            <p>{{ nowWeather.text }}</p>
          </div>
          <div class="weather_time">
            <p>{{ currentDay }}</p>
            <p class="air">· 空气质量：良好</p>
          </div>
        </div>
        <div class="box_list">
          <div class="list_item">
            <p>能见度</p>
            <img :src="`${require(`@/assets/hs/icon_概率.png`)}`" alt="" />
            <p class="item_value">{{ nowWeather.vis }}km</p>
          </div>
          <div class="list_item">
            <p>降雨量</p>
            <img :src="`${require(`@/assets/hs/icon_降雨量.png`)}`" alt="" />
            <p class="item_value">{{ parseInt(nowWeather.precip) }}mm</p>
          </div>
          <div class="list_item">
            <p>相对湿度</p>
            <img :src="`${require(`@/assets/hs/icon_湿度.png`)}`" alt="" />
            <p class="item_value">{{ nowWeather.humidity }}%</p>
          </div>
          <div class="list_item">
            <p>风力等级</p>
            <img :src="`${require(`@/assets/hs/icon_风力.png`)}`" alt="" />
            <p class="item_value">{{ nowWeather.windScale }}级</p>
          </div>
          <div class="list_item">
            <p>风速</p>
            <img :src="`${require(`@/assets/hs/icon_风速.png`)}`" alt="" />
            <p class="item_value">{{ nowWeather.windSpeed }}m/s</p>
          </div>
        </div>
        <div class="box_chart">
          <div class="weather_chart" id="weatherChart" ref="weatherChart"></div>
        </div>
        <div class="box_chart_foot">
          <div class="item" v-for="(dayInfo, index) in days" :key="index">
            <div class="icon_seven">
              <img
                :src="`${require(`@/assets/hs/${dayInfo.weatherIcon}.png`)}`"
                alt=""
                class="Img"
              />
            </div>
            <p>{{ dayInfo.week }}</p>
            <p>{{ dayInfo.day }}</p>
          </div>
        </div>
      </div>
    </card>
    <card title="降雨量统计" styles="margin-top: 24px">
      <div class="card_content">
        <div class="rain_statistic_list fr">
          <div class="item box_style">
            <p>日降雨量</p>
            <img src="@/assets/hs/icon_降雨量.png" alt="" />
            <p class="rain_value">{{ parseInt(nowWeather.precip) }}mm</p>
          </div>
          <div class="item box_style">
            <p>月降雨量</p>
            <img src="@/assets/hs/icon_降雨量.png" alt="" />
            <p class="rain_value">{{ parseInt(curMonthRain) }}mm</p>
          </div>
          <div class="item box_style">
            <p>年降雨量</p>
            <img src="@/assets/hs/icon_降雨量.png" alt="" />
            <p class="rain_value">{{ parseInt(curYearRain) }}mm</p>
          </div>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
import Card from '@/components/Card.vue';
import * as Api from '@/api';

import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn'; // 引入中文语言包
dayjs.locale('zh-cn');
export default {
  name: 'CardWeather',
  components: {
    Card,
  },
  data() {
    return {
      weatherInfoList: [
        { code: 'vis', name: '降水概率', icon: 'icon_概率', value: '86%' },
        { code: 'precip', name: '降雨量', icon: 'icon_降雨量', value: '57%' },
        { code: 'humidity', name: '相对湿度', icon: 'icon_湿度', value: '59.2%' },
        { code: 'windScale', name: '风力等级', icon: 'icon_风力', value: '2级' },
        { code: 'windSpeed', name: '风速', icon: 'icon_风速', value: '0.52m/s' },
      ],
      weatherInfoList2: [{ type: 'sun', date: '08-27' }],
      echartsOpt: {
        grid: {
          top: '10%',
          left: '0%',
          right: '0%',
          bottom: '30%',
          containLabel: false,
        },
        xAxis: {
          show: false,
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        },
        yAxis: {
          show: false,
          type: 'value',
        },
        series: [
          {
            label: {
              show: true,
              position: 'top',
              color: '#BEE1F9',
            },
            data: [32, 35, 28, 31, 33],
            type: 'line',
            lineStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: 'rgba(254, 126, 54, 0.1)' },
                  { offset: 1, color: 'rgba(254, 126, 54, 0.7)' },
                ],
              },
            },
          },
          {
            label: {
              show: true,
              position: 'top',
              color: '#BEE1F9',
            },
            data: [25, 26, 23, 22, 28],
            type: 'line',
            lineStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: 'rgba(13, 165, 251, 0.15)' },
                  { offset: 1, color: 'rgba(140, 235, 255, 0.60)' },
                ],
              },
            },
          },
        ],
      },
      days: [],
      curWeatherType: 'auto',
      nowWeather: {
        temp: '--',
        text: '--',
        vis: '0',
        precip: '0',
        humidity: '--',
        windScale: '--',
        windSpeed: '--',
      },
      nowWeatherIcon: 'icon_wushuju',
      curMonthRain: 0,
      curYearRain: 0,
    };
  },
  mounted() {
    this.renderCharts();
    this.getRainInfo();
  },
  computed: {
    currentDay() {
      const today = new Date();
      const text = dayjs(today).format('YYYY.MM.DD dddd');
      return text;
    },
  },
  methods: {
    getRainInfo() {
      Api.getRainFallInfo().then((res) => {
        if (res.success) {
          const { data } = res;
          const curMonth = dayjs().month();
          this.curMonthRain = data[curMonth].rainFallCount;
          this.curYearRain = data.reduce((accumulator, currentItem) => {
            return accumulator + currentItem.rainFallCount;
          }, 0);
        }
      });
    },
    getNowWeather() {
      Api.getNowWeatherInfo().then((res) => {
        if (res.success) {
          const { now } = res.data;
          this.nowWeather = { ...this.nowWeather, ...now };
          this.nowWeatherIcon = this.dealWeatherIcon(now.text);
        }
      });
    },
    getSevenDayWeather() {
      let weatherChart = this.$echarts.init(document.getElementById('weatherChart'));

      Api.get7dWeatherInfo().then((res) => {
        const tempMaxArr = [];
        const tempMinArr = [];
        if (res.success) {
          const { daily } = res.data;
          this.dealSevenDayIcon(daily);
          daily.forEach((item, index) => {
            if (index < 5) {
              tempMaxArr.push(item.tempMax);
              tempMinArr.push(item.tempMin);
            }
          });
          weatherChart.setOption({ series: [{ data: tempMaxArr }, { data: tempMinArr }] });
        }
      });
    },
    dealSevenDayIcon(daily) {
      const today = new Date();
      const days = [];
      for (let i = 0; i < 5; i++) {
        const weatherIcon = this.dealWeatherIcon(daily[i].textDay);
        const day = dayjs(today).add(i, 'day').format('MM.DD');
        const week = dayjs(today).add(i, 'day').format('dddd');
        days.push({ day, week, weatherIcon });
      }
      this.days = days;
    },
    dealRainLevel(rain) {
      const rainLevels = [
        { min: 0, max: 10, level: '无雨' },
        { min: 10, max: 20, level: '小雨' },
        { min: 20, max: 30, level: '中雨' },
        { min: 30, max: 50, level: '大雨' },
        { min: 50, max: Infinity, level: '暴雨' },
      ];
      for (let i = 0; i < rainLevels.length; i++) {
        if (rain >= rainLevels[i].min && rain < rainLevels[i].max) {
          return rainLevels[i].level;
        }
      }
      return '未知';
    },
    dealWeatherIcon(weather) {
      switch (true) {
        case weather.includes('晴'):
          return 'icon_qingtian';
        case weather.includes('多云'):
          return 'icon_duoyun';
        case weather.includes('阴'):
          return 'icon_yintian';
        case weather.includes('雨'):
          return 'icon_zhenyu';
        case weather.includes('雪'):
          return 'icon_xiaoxue';
        default:
          return 'icon_wushuju';
      }
    },
    renderCharts() {
      this.getNowWeather();
      this.getSevenDayWeather();
      let weatherChart = this.$echarts.init(document.getElementById('weatherChart'));
      weatherChart.setOption(this.echartsOpt);
    },
    handleControlWeather() {
      if (this.curWeatherType == 'auto') {
        this.$Model.i3dDayAndNight('move');
        this.$Storage.set('weatherType', 'move');
        this.curWeatherType = 'move';
      } else {
        this.$Model.i3dDayAndNight('auto');
        this.$Storage.set('weatherType', 'auto');
        this.curWeatherType = 'auto';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.weather_box {
  padding: 24px 0;
  height: 490px;
  .box_header {
    display: flex;
    justify-content: flex-start;
    padding: 0 20px;
    align-items: center;
    p {
      font-size: 16px;
      font-weight: 400;
      color: rgba(190, 225, 249, 0.8);
      line-height: 24px;
      letter-spacing: 1px;
      margin-bottom: 8px;
    }
    .weather_icon {
      width: 64px;
      height: 64px;
      cursor: pointer;
    }
    .weather_temp {
      font-size: 44px;
      font-weight: 500;
      color: #fff;
      text-shadow: 0px 0px 4px rgba(98, 166, 241, 0.7);
      margin-left: 15px;
    }
    .weather_info {
      margin-left: 30px;
    }
    .weather_time {
      margin-left: 30px;
      .air {
        width: 154px;
        height: 20px;
        line-height: 20px;
        padding-left: 5px;
        font-size: 14px;
        background: linear-gradient(
          90deg,
          rgba(70, 113, 157, 0.5) 0%,
          rgba(70, 113, 157, 0.1) 100%
        );
        border-radius: 10px;
      }
    }
  }

  .box_list {
    display: flex;
    justify-content: space-around;
    margin-top: 20px;
    .list_item {
      width: 82px;
      height: 96px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-evenly;
      background: rgba(39, 95, 143, 0.5);
      border: 1px solid;
      border-image: linear-gradient(
          180deg,
          rgba(79, 139, 189, 0.3),
          rgba(54, 105, 148, 0.15),
          rgba(39, 95, 143, 0.92)
        )
        1 1;
      p {
        color: rgba(190, 225, 249, 0.8);
      }
      img {
        display: block;
        width: 24px;
        height: 24px;
      }
      .item_value {
        color: #fff;
        letter-spacing: 1px;
        text-shadow: 0px 0px 4px rgba(98, 166, 241, 0.2);
      }
    }
  }
  .box_chart {
    width: 456px;
    height: 200px;
    .weather_chart {
      width: 150%;
      height: 150%;
    }
  }
  .box_chart_foot {
    display: flex;
    justify-content: space-around;
    width: 490px;
    height: 65px;
    .item {
      text-align: center;
      .icon_seven {
        width: 32px;
        margin: auto;
      }
      p {
        color: rgba(190, 225, 249, 0.8);
      }
    }
  }

  .rain_statistic_list {
    .item {
      width: 152px;
      height: 150px;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: center;
      img {
        display: block;
        width: 30px;
        height: 30px;
      }
      .rain_value {
        color: #fff;
        letter-spacing: 1px;
        text-shadow: 0px 0px 4px rgba(98, 166, 241, 0.2);
        font-size: 16px;
      }
    }
  }
}
</style>
